app.directive('regulationClientDomains', ['$rootScope', 'utilsService', function ($rootScope, utilsService) {
    return {
        restrict: "E",
        templateUrl: "/templates/partials/directives/domains/domains-tree.html",
        scope: {
            collection: '=',
            onChange: '=',
            currentNode: '=',
            childrenKey: '@',
            navigation: '='
        },
        link: function (scope) {
            scope.tree = null;
            scope.currentDomains = [];
            scope.selectedDomain = null;
            scope.sort_key = 'name';
            scope.navigation = scope.navigation || false;

            scope.$watch('collection', function (collection) {
                scope.tree = new Nested(collection, {children_key: scope.childrenKey || '_children'});
                scope.currentDomains = scope.tree.data;
                scope.selectedDomain = null;
            });

            scope.getChildNodes = function (node) {
                if (utilsService.isSet(node)) {
                    scope.currentDomains = node.hasChildNodes() ? node.childNodes() : [];
                    scope.sort_key = parseInt(node.getProperty('depth'), 10) < 2 ? 'name' : 'position';
                } else {
                    scope.currentDomains = scope.tree.data;
                    scope.sort_key = 'name';
                }
                scope.selectedDomain = node;
                scope.onChange(node);
            };

            scope.goBack = function (rootNode) {
                if (!scope.selectedDomain) {
                    return;
                }

                var parentNode = rootNode ? null : scope.selectedDomain.parentNode();
                scope.getChildNodes(parentNode);
            };

            $rootScope.$on('regulations.client.domains.navigate', function (e, data) {
                if (!scope.tree) {
                    return;
                }
                if (!data || !data.node) {
                    data.node = null;
                }
                if (data.node !== null && !isNaN(data.node)) {
                    var nodes = scope.tree.retrieveNodesBy('id', data.node);
                    if (!nodes || !nodes.length) {
                        return;
                    }
                    data.node = nodes.length ? utilsService.first(nodes) : null;
                }
                scope.getChildNodes(data.node);
            });

            $rootScope.$on('regulations.client.domains.goBack', function (e, data) {
                scope.goBack(data.rootNode || false);
            });
        }
    }
}]);
